import { render } from "./UpdateAnnotationSetModal.vue?vue&type=template&id=985d4508&scoped=true"
import script from "./UpdateAnnotationSetModal.vue?vue&type=script&lang=js"
export * from "./UpdateAnnotationSetModal.vue?vue&type=script&lang=js"

import "./UpdateAnnotationSetModal.vue?vue&type=style&index=0&id=985d4508&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-985d4508"]])

export default __exports__